export const ContinueStatement = {
  print: () => 'continue;'
};
